"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  min-width: 100%;\n  justify-content: center;\n  align-items: center;\n  margin: auto 0px;\n  gap: 10px;\n  fieldset {\n    flex: 1;\n  }\n"])));
var mapProps = function mapProps(labels) {
  var idPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var choices = labels.map(function (entry, index) {
    return {
      value: entry.value,
      title: entry.label,
      id: "".concat(idPrefix, "item-").concat(index)
    };
  });
  return choices;
};
var RangePicker = function RangePicker(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    onChangeValue = _ref.onChangeValue,
    choices = _ref.choices,
    selection = _ref.selection,
    idPrefix = _ref.idPrefix;
  return /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: icon,
    group: "midLight",
    size: 1
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, title)))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 10
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Picker, {
    selected: selection,
    label: title,
    onChange: function onChange(e) {
      onChangeValue(e.target.value);
      console.log(e.target.value);
    },
    groupName: title,
    items: mapProps(choices, idPrefix),
    columns: {
      sm: 1,
      md: 3,
      lg: 3
    }
  }))))));
};
var _default = RangePicker;
exports.default = _default;